import { getPermissions, isPermissionEnabled } from "./permissionStorage";

function readSessionUser() {
  try {
    const raw = localStorage.getItem("user");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

function legacyUserFlag(user, key) {
  const v = user?.[key];
  return v === 1 || v === "1" || v === true;
}

function perm(permissions, key) {
  return isPermissionEnabled(permissions?.[key]);
}

/**
 * Migration applications menu and assign flows.
 * Uses role permissions first; falls back to legacy user.migrationaccess.
 */
export function canAccessMigrationApplications(permissions, user = readSessionUser()) {
  if (legacyUserFlag(user, "migrationaccess")) return true;
  const p = permissions || getPermissions() || {};
  return (
    perm(p, "desk_migration") ||
    perm(p, "my_mig_followups") ||
    perm(p, "all_mig_followups") ||
    perm(p, "all_followups")
  );
}

/**
 * Education applications menu and assign flows.
 */
export function canAccessEducationApplications(permissions, user = readSessionUser()) {
  if (legacyUserFlag(user, "educationaccess")) return true;
  const p = permissions || getPermissions() || {};
  return (
    perm(p, "desk_education") ||
    perm(p, "my_edu_followups") ||
    perm(p, "all_edu_followups") ||
    perm(p, "all_followups")
  );
}

/** Derive legacy API payload values from effective permissions when saving users. */
export function deriveLegacyApplicationAccessFlags(permissions) {
  const p = permissions || {};
  return {
    mig_access: canAccessMigrationApplications(p, null) ? 1 : 0,
    edu_access: canAccessEducationApplications(p, null) ? 1 : 0,
  };
}
